"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnErrorCallback = void 0;
var react_1 = require("react");
/**
 * Resolves errors for {@link AttributeFilterButton} component.
 */
exports.useOnErrorCallback = function (onError, errors) {
    var error = react_1.useMemo(function () { return errors.find(function (error) { return !!error; }); }, [errors]);
    return react_1.useEffect(function () {
        if (onError && error) {
            onError(error);
        }
    }, errors);
};
//# sourceMappingURL=useOnErrorCallback.js.map